import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Global 401 handler: wipe the token so ProtectedRoute redirects to /login.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err?.config?.url || "";
    if (err?.response?.status === 401 && !url.includes("/auth/")) {
      localStorage.removeItem("mlforge_token");
      delete api.defaults.headers.common["Authorization"];
      if (typeof window !== "undefined" && !window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  },
);

export const endpoints = {
  config: () => api.get("/config"),
  listProjects: () => api.get("/projects"),
  getProject: (id) => api.get(`/projects/${id}`),
  createProject: (data) => api.post("/projects", data),
  deleteProject: (id) => api.delete(`/projects/${id}`),
  uploadDataset: (id, file, goal) => {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("goal_prompt", goal || "");
    return api.post(`/projects/${id}/upload`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  startTraining: (id, target) => api.post(`/projects/${id}/train`, { target_column: target || null }),
  trainingStatus: (id) => api.get(`/projects/${id}/status`),
  overview: (id) => api.get(`/projects/${id}/overview`),
  plan: (id) => api.get(`/projects/${id}/plan`),
  eda: (id) => api.get(`/projects/${id}/eda`),
  preprocessing: (id) => api.get(`/projects/${id}/preprocessing`),
  leaderboard: (id) => api.get(`/projects/${id}/leaderboard`),
  evaluation: (id) => api.get(`/projects/${id}/evaluation`),
  tuning: (id) => api.get(`/projects/${id}/tuning`),
  explain: (id) => api.get(`/projects/${id}/explain`),
  report: (id) => api.get(`/projects/${id}/report`),
  downloadUrl: (id, kind) => `${API}/projects/${id}/download/${kind}`,
  messages: (id) => api.get(`/projects/${id}/messages`),
  sendMessage: (id, message) => api.post(`/projects/${id}/chat`, { message }),
};
